import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ClauseSearchResult } from '../types/clause';
import { CaseSearchResult } from '../types/case';

interface SearchState {
  clauseResults: ClauseSearchResult[];
  caseResults: CaseSearchResult[];
  lastQuery: string;
  loading: boolean;
  error: string | null;
}

const initialState: SearchState = {
  clauseResults: [],
  caseResults: [],
  lastQuery: '',
  loading: false,
  error: null,
};

const searchSlice = createSlice({
  name: 'search',
  initialState,
  reducers: {
    setClauseResults: (state, action: PayloadAction<ClauseSearchResult[]>) => {
      state.clauseResults = action.payload;
      state.loading = false;
      state.error = null;
    },
    setCaseResults: (state, action: PayloadAction<CaseSearchResult[]>) => {
      state.caseResults = action.payload;
      state.loading = false;
      state.error = null;
    },
    setLastQuery: (state, action: PayloadAction<string>) => {
      state.lastQuery = action.payload;
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setError: (state, action: PayloadAction<string>) => {
      state.error = action.payload;
      state.loading = false;
    },
    clearResults: (state) => {
      state.clauseResults = [];
      state.caseResults = [];
      state.lastQuery = '';
      state.error = null;
    },
  },
});

export const {
  setClauseResults,
  setCaseResults,
  setLastQuery,
  setLoading,
  setError,
  clearResults,
} = searchSlice.actions;
export default searchSlice.reducer;
